import { Subscription } from "./billing";

export interface DataPoint {
  date: string;
  resolutions: number;
  phone_calls: number;
  conversations: number;
  customers: number;
}

export enum ThemeOption {
  CLASSIC_BLUE = "classic_blue",
  FOREST_GREEN = "forest_green",
  ROYAL_PURPLE = "royal_purple",
  SUNSET_ORANGE = "sunset_orange",
  OCEAN_TEAL = "ocean_teal",
  RUBY_RED = "ruby_red",
}

export interface WidgetCustomisation {
  theme_option: ThemeOption;
  preset_questions: string[];
  dark_mode: boolean;
}

export interface MonthlyTotals {
  resolutions: number;
  phone_calls: number;
}

export interface Workspace {
  id: number;
  name: string;
  slug: string;
  avatar: string;
  shop_url?: string;
  active_subscription: Partial<Subscription>;
  widget_customisation: WidgetCustomisation;
  monthly_totals: MonthlyTotals;
}
